import { render, staticRenderFns } from "./AntragsdatenPruefen.vue?vue&type=template&id=13acbdb6"
import script from "./AntragsdatenPruefen.vue?vue&type=script&lang=js"
export * from "./AntragsdatenPruefen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports